import { SendEmailRequest, SendEmailResponse } from '../models/Email';
import { emailApiClient } from './emailApiClient';

interface ApiProblemDetails {
  detail?: string;
}

const postToEmailApi = async (path: string, payload: unknown): Promise<SendEmailResponse> => {
  const response = await emailApiClient(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    const errorBody = (await response.json().catch(() => undefined)) as ApiProblemDetails | undefined;
    throw new Error(errorBody?.detail ?? `API responded with status ${response.status}`);
  }

  return (await response.json()) as SendEmailResponse;
};

export const sendEmail = async (payload: SendEmailRequest): Promise<SendEmailResponse> =>
  postToEmailApi('', payload);
